import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Checkbox, Input } from "components/__new/common/form";
import TabOnboardingCompliance from "components/__new/common/TabOnboardingCompliance";
import Maybe from "components/__new/common/Maybe";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";


const OnboardingComplianceBvn = () => {
    const history = useHistory();
    
    
    const [form, setForm] = useState({
        bvn: "",
        type: "",
        phoneNumber: "",
        dateOfBirth: "",
    })

    
    const submitForm = async (e) => {
        e.preventDefault();
        history.push("/get-started/compliance/bvn/success");
    }
    
    
    return (
        <div>
            
            <DynamicHeadTag
                headerText="BVN Compliance"
            />
            
            <div className="py-14">
                <TabOnboardingCompliance index="1" />
            </div>
            
            <div className="box">
                <div className="mx-auto my-8 max-w-xl">
                    <div className="text-center">
                        <div className="text-2xl font-bold">
                            BVN Verification
                        </div>
                        
                        <div className="mt-2 text-[#374151]">
                            To confirm your identity, you need to validate your BVN.&nbsp;
                            <br className="hidden md:block" />
                            This validation doesnt give earnipay access to any of your bank information
                        </div>
                    </div>
                    
                    <form onSubmit={submitForm} className="max-w-sm mx-auto">
                        <div className="my-10">
                            
                            <Input
                                type="number"
                                label="Enter Director’s Bank Verification Number"
                                placeholder="Enter BVN Number"
                                value={form.bvn}
                                onChange={(e) => setForm({...form, bvn: e.target.value})}
                            />
                            
                            <div>
                                Choose Preferred Verification type
                                <span className="form-input-required">*</span>
                            </div>
                            
                            <div className="mt-2 p-6 border border-gray-100 rounded-md">
                                <div>
                                    <Checkbox
                                        type="radio"
                                        label="Use Phone Number for Verification"
                                        checked={form.type === "phoneNumber"}
                                        onChange={(e) => setForm({...form, type: "phoneNumber"})}
                                    />
                                </div>
                                
                                <Maybe condition={form.type === "phoneNumber"}>
                                    <div className="mt-4 mb-8 px-8 pb-4 text-[#718096] border-b border-gray-200">
                                        <Input
                                            type="number"
                                            label="Enter Phone Number"
                                            placeholder="Enter Phone Number"
                                            value={form.phoneNumber}
                                            onChange={(e) => setForm({...form, phoneNumber: e.target.value})}
                                        />
                                    </div>
                                </Maybe>
                                
                                <div className="mt-6">
                                    <Checkbox
                                        type="radio"
                                        label="Use Date of Birth for Verification"
                                        checked={form.type === "dateOfBirth"}
                                        onChange={(e) => setForm({...form, type: "dateOfBirth"})}
                                    />
                                </div>
                                
                                <Maybe condition={form.type === "dateOfBirth"}>
                                    <div className="mt-4 px-8 text-[#718096]">
                                        <Input
                                            type="date"
                                            label="Enter Director’s Date of Birth"
                                            placeholder="Select date"
                                            value={form.dateOfBirth}
                                            onChange={(e) => setForm({...form, dateOfBirth: e.target.value})}
                                        />
                                    </div>
                                </Maybe>
                            </div>
                            
                        </div>
                        
                        <div className="mt-8 flex justify-between">
                            <button type="submit" className="btn btn-block btn-ep-primary btn-lg mr-2">
                                Verify
                            </button>
                            <Link to="/get-started/compliance" className="btn btn-block btn-transparent-black btn-lg">
                                Cancel
                            </Link>
                        </div>
                    </form>
                    
                </div>
            </div>
        </div>
    )
}


export default OnboardingComplianceBvn;